import i18n from '@/main';

import ptBr from './pt-br.json';
import en from './en.json';
import es from './es.json';

export const locale = {
    init: i18n => {
        i18n.mergeLocaleMessage('pt-BR', {
            relatorioExportacao: {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            relatorioExportacao: {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            relatorioExportacao: {
                ...es
            }
        });
    }
};

export const beforeEnter = (_to, _from, next) => {
    locale.init(i18n);
    next();
};
